// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__wfCcj","label":"Dropdown_label__Irv6K","trigger":"Dropdown_trigger__g5MjF","option":"Dropdown_option__7JU0A","icon":"Dropdown_icon__zTC7Z"};